var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ag-theme-alpine",staticStyle:{"height":"300px","display":"flex","justify-content":"center"}},[_c('AgGridVue',{staticClass:"ag-theme-alpine",staticStyle:{"width":"610px","height":"200px"},attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }